/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Form_DescInputs */

const en_support_form_desc = /** @type {(inputs: Support_Form_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We usually reply within one business day.`)
};

const id_support_form_desc = /** @type {(inputs: Support_Form_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biasanya kami balas dalam satu hari kerja.`)
};

/**
* | output |
* | --- |
* | "We usually reply within one business day." |
*
* @param {Support_Form_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const support_form_desc = /** @type {((inputs?: Support_Form_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Form_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_support_form_desc(inputs)
	return en_support_form_desc(inputs)
});